const styles = theme => ({
  holder: {
    margin: theme.spacing(3),
    //maxWidth: '500px',
    marginRight: 'auto',
    marginLeft: 'auto',
    borderRadius: 10,
    overflow: 'hidden',
    //backgroundColor: 'white',
    minHeight: 247,
    width: '50%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: '0px',
      margin: 0,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

export default styles
